<ambita-cadastre-report-summary>
  <div class="ambita-cadastre-report__summary-wrapper" show="{ lookupData.data }">
    <h3 class="ambita-report-h3">
      <span class="ambita-cadastre-report__cadastre">{ lookupData.data.cadastre }</span>
      <span class="ambita-cadastre-report__address">{ getShortStreetAddress() }</span>
      <span class="ambita-cadastre-report__location">{ getPostalLocation() }</span>
    </h3>
    <h3 class="ambita-cadastre-report__cadastre-status ambita-report-h3"
        show="{ lookupData.data.isHistoricalTechnicalRegisteredLand }">
      { i18n.propertyLookup.historicCadastre }
    </h3>
    <h3 class="ambita-cadastre-report__cadastre-status ambita-report-h3" show="{ lookupData.data.isSectioned }">
      { i18n.propertyLookup.sectionedCadastre }
    </h3>
    <div class="ambita-cadastre-report__section ambita-cadastre-report__summary" onclick="{ onSummaryLinkClick }"
         show="{ isCadastreReport() || isCadastreInfo() }">
      <h4 class="ambita-report-h4">{ i18n.propertyLookup.summary }</h4>
      <ul class="ambita-report-ul">
        <li class="ambita-cadastre-report-summary__cadastre-sections"
            show="{ lookupData.data.sections.length && isCadastreReport() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__cadastre-sections">
            { i18n.propertyLookup.indexSections } ({ count('sections') })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__owners" show="{ countOwners() > 0 && isCadastreReport() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__owners">
            { i18n.propertyLookup.indexOwners } ({ countOwners() })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__conveyance"
            show="{ lookupData.data.conveyance && isCadastreReport() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__conveyance">
            { i18n.propertyLookup.indexConveyance }
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__cadastre-info" show="{ isCadastreReport() || isCadastreInfo() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__cadastre-info">
            { i18n.propertyLookup.indexCadastreInfo }
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__unregistered-ownerships"
            show="{ isCadastreReport() || isCadastreInfo() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__cadastre-unregistered-ownerships">
            { i18n.propertyLookup.indexUnregisteredOwnerships } ({ countUnregisteredOwnerships() })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__cultural-heritages"
            show="{ isCadastreReport() || isCadastreInfo() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__cadastre-heritages">
            { i18n.propertyLookup.indexCultureHeritage } ({ count('singleHeritages') })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__soil-contaminations"
            show="{ isCadastreReport() || isCadastreInfo() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__cadastre-soil-contaminations">
            { i18n.propertyLookup.indexSoilContamination } ({ count('soilContaminations') })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__complaints" show="{ isCadastreReport() || isCadastreInfo() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__cadastre-complaints">
            { i18n.propertyLookup.indexComplaints } ({ count('complaints') })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__affairs" show="{ isCadastreReport() || isCadastreInfo() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__cadastre-affairs">
            { i18n.propertyLookup.indexAffairs } ({ count('affairs') })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__addresses" show="{ isCadastreReport() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__addresses">
            { i18n.propertyLookup.indexAddresses } ({ countAddresses() })
          </a>
        </li>
        <li class="ambita-cadastre-report-summary__buildings" show="{ isCadastreReport() }">
          <a class="ambita-report-link" href="#ambita-cadastre-report__buildings">
            { i18n.propertyLookup.indexBuildings } ({ count('buildings') })
          </a>
        </li>
      </ul>
    </div>
  </div>

  <script>
    import { init } from './cadastreReportSummaryController';

    init(this);
  </script>
</ambita-cadastre-report-summary>
